import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const Footer: React.FC  = () => {
    return (
        <Paper 
            component="footer"
            sx={{ 
                mt: 'auto',
                py: 2,
                borderRadius: 0,
                borderTop: '1px solid',
                borderColor: 'divider'
            }}
        >
            <Typography variant="body2" align="center" gutterBottom>
                <Link color="inherit" href="/privacy">Privacy Policy</Link>
                {' • '}
                <Link color="inherit" href="/delete">Delete My Data</Link>
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
                {'Copyright © '}
                <Link color="inherit" href="/">
                    Famous Initials LLC
                </Link>{' '}
                {new Date().getFullYear()}.
            </Typography>
        </Paper>
    );
}

export default Footer;